/**
 * Domain enums — PLAN.md §5.
 * Kept as `const` tuples + derived union types so zod schemas, Prisma
 * enums and TS types stay in sync from a single source of truth.
 */
export const SUBSCRIPTION_STATUSES = [
    'ACTIVE',
    'BLOCKED',
    'EXPIRED',
    'FINISHED',
];
export const PAYMENT_FLOWS = ['DIRECT', 'TWO_STEP', 'TOPUP_BALANCE'];
export const TRANSACTION_TYPES = ['PAYMENT', 'CONVERSION', 'TOPUP'];
export const RATE_SOURCES = ['BILL', 'SCREENSHOT', 'MANUAL'];
export const ACCOUNT_KINDS = ['BANK', 'CARD', 'SERVICE'];
export const NOTIFICATION_KINDS = ['EXPIRY', 'RENEWAL', 'STATUS'];
export const REPORT_STATUSES = ['PENDING', 'PROCESSING', 'READY', 'FAILED'];
/**
 * MONTH | YEAR | NONE — Subscription.renewalPeriod.
 * `NONE` is a one-off / single payment: there is no cycle to renew, so the
 * matcher ignores its date and amount signals and the notification scan never
 * estimates a renewal for it (an `expiresAt` still warns, when one is set).
 */
export const RENEWAL_PERIODS = ['MONTH', 'YEAR', 'NONE'];
/**
 * Bill OCR pipeline status — PLAN.md §4
 * (PENDING -> PROCESSING -> EXTRACTED -> CONFIRMED/FAILED).
 */
export const OCR_STATUSES = [
    'PENDING',
    'PROCESSING',
    'EXTRACTED',
    'CONFIRMED',
    'FAILED',
];
/**
 * Kind of operation read off a Russian bank receipt ("Тип"/"Операция").
 * Kept coarse: the receipt wording is free text, so anything the LLM cannot
 * map collapses to OTHER.
 */
export const BILL_OPERATION_TYPES = [
    'PAYMENT',
    'CONVERSION',
    'TOPUP',
    'TRANSFER',
    'OTHER',
];
/**
 * What the Telegram spending bot thinks the message is (LLM intent for a plain
 * text message, OCR `operationType` for an uploaded bill).
 */
export const SPENDING_DRAFT_KINDS = ['PAYMENT', 'CONVERSION', 'QUERY'];
/** How the draft entered the bot: a document, plain text, or both. */
export const SPENDING_DRAFT_SOURCES = [
    'DOCUMENT',
    'TEXT',
    'DOCUMENT_WITH_CAPTION',
];
/** Draft lifecycle: NEW -> SUGGESTED -> CONFIRMED, with DISCARDED/FAILED as exits. */
export const SPENDING_DRAFT_STATUSES = [
    'NEW',
    'SUGGESTED',
    'CONFIRMED',
    'DISCARDED',
    'FAILED',
];
/**
 * Balance ledger row meaning (LLM_CONTEXT/11-balance.md): `FUNDING` is money
 * the company gave the owner, `CORRECTION` is a signed adjustment.
 */
export const BALANCE_ENTRY_KINDS = ['FUNDING', 'CORRECTION'];
/** Which surface recorded a balance entry. */
export const BALANCE_ENTRY_SOURCES = ['MANUAL', 'TELEGRAM', 'MCP', 'IMPORT'];
//# sourceMappingURL=enums.js.map